module.exports = __webpack_public_path__ + "img/weihnachten.0c30b87e.jpg";